import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import {
  glassCardStyles,
  gradientTextStyles,
  Page,
  theme,
  typography,
} from "../Homepage/styles";

const cardLinkNoUnderline = css`
  &,
  &:hover,
  &:focus,
  &:active,
  &:visited {
    text-decoration: none;
    color: inherit;
  }

  &:hover *,
  &:focus *,
  &:active *,
  &:visited * {
    text-decoration: none;
  }
`;

export const SearchPage = styled(Page)`
  background: hsl(var(--hp-background));
  background-image: none;
`;

export const SearchHero = styled.section`
  position: relative;
  padding: 128px 16px 40px;
  overflow: hidden;
  text-align: center;

  @media (max-width: 768px) {
    padding: 104px 16px 32px;
  }
`;

export const SearchHeroBg = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom right,
    hsl(var(--hp-primary) / 0.1) 0%,
    hsl(var(--hp-background)) 50%,
    hsl(var(--hp-accent) / 0.05) 100%
  );
`;

export const SearchHeroInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 48rem;
  margin: 0 auto;
`;

export const SearchHeroTitle = styled.h1`
  margin: 0 0 16px;
  color: ${theme.foreground};
  font-size: 2.25rem;
  font-weight: ${typography.weights.bold};
  line-height: 1.2;
  word-break: break-word;

  @media (min-width: 768px) {
    font-size: 3rem;
    margin-bottom: 24px;
  }

  span {
    ${gradientTextStyles}
  }
`;

export const SearchHeroSubtitle = styled.p`
  margin: 0 0 24px;
  color: ${theme.textMuted};
  font-size: 1rem;
  line-height: 1.6;
`;

export const SearchHeroFormWrap = styled.div`
  display: flex;
  justify-content: center;

  .site-search--hero {
    width: 100%;
    max-width: 100%;
  }
`;

export const SearchFeedSection = styled.section`
  padding: 0 16px 80px;
`;

export const SearchFeedInner = styled.div`
  max-width: 48rem;
  margin: 0 auto;
`;

export const SearchResultsSummary = styled.p`
  margin: 0 0 24px;
  color: ${theme.textMuted};
  font-size: 0.875rem;
  line-height: 1.5;

  strong {
    color: ${theme.foreground};
    font-weight: ${typography.weights.medium};
  }
`;

export const SearchStateCard = styled.div`
  ${glassCardStyles}
  padding: 48px 24px;
  border-radius: 1rem;
  text-align: center;
`;

export const SearchStateTitle = styled.p`
  margin: 0 0 8px;
  color: ${theme.foreground};
  font-size: 1.125rem;
  font-weight: ${typography.weights.semibold};
`;

export const SearchStateText = styled.p`
  margin: 0;
  color: ${theme.textMuted};
  font-size: 0.9375rem;
  line-height: 1.6;
`;

export const SearchResultList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SearchResultLink = styled(Link)`
  display: block;
  ${cardLinkNoUnderline}
`;

export const SearchResultCard = styled.article`
  ${glassCardStyles}
  padding: 24px;
  border-radius: 1rem;
  border-color: hsl(var(--hp-border) / 0.5);
  transition:
    border-color 0.3s ease,
    background-color 0.3s ease;

  &:hover {
    border-color: hsl(var(--hp-primary) / 0.4);
  }
`;

export const SearchResultMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const SearchResultType = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border: 1px solid hsl(var(--hp-border) / 0.6);
  border-radius: 9999px;
  color: ${theme.textMuted};
  font-size: 0.75rem;
  font-weight: ${typography.weights.medium};
  line-height: 1.4;
`;

export const SearchResultAnalyst = styled.span`
  color: ${theme.textMuted};
  font-size: 0.75rem;
  line-height: 1.4;
`;

export const SearchResultDate = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${theme.textMuted};
  font-size: 0.75rem;
  line-height: 1.4;

  .material-icons {
    font-size: 14px;
    line-height: 1;
  }
`;

export const SearchResultTitle = styled.h2`
  margin: 0 0 8px;
  color: ${theme.foreground};
  font-size: 1.125rem;
  font-weight: ${typography.weights.bold};
  line-height: 1.35;
  transition: color 0.2s ease;

  ${SearchResultLink}:hover & {
    color: ${theme.primary};
  }
`;

export const SearchResultExcerpt = styled.p`
  margin: 0;
  color: ${theme.textMuted};
  font-size: 0.875rem;
  line-height: 1.6;
`;

export const SearchPaginationWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

export const SearchSkeletonCard = styled.div`
  height: 140px;
  border-radius: 1rem;
  border: 1px solid hsl(var(--hp-border) / 0.5);
  background: hsl(var(--hp-muted) / 0.35);
  animation: search-page-pulse 1.5s ease-in-out infinite;

  @keyframes search-page-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.55;
    }
  }
`;
